import { Fab, type FabProps } from '@mui/material';

export type ToolbarButtonProps = FabProps;

export const ToolbarButton = (props: ToolbarButtonProps) => {
  return <Fab size="medium" color="inherit" {...props} />;
};
